import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { TeamHome, useTeamMembers, useTeamTasks, createTeamMember, createTask, mutateTask, openDm, TEAM_ROOT, COMMS_ROOT } from './comms'

/**
 * V2 Team home — route wrapper.
 *   /square/command-center/team
 *
 * Owns the roster + task hooks. Adding a member / creating a task are real,
 * audited saves. No fabricated members or tasks. (The add-member API is
 * admin-gated server-side.)
 */
export default function SquareCodeTeamRoute() {
  const navigate = useNavigate()
  const members = useTeamMembers()
  const tasks = useTeamTasks()
  return (
    <TeamHome
      members={members.items}
      tasks={tasks.items}
      membersLoading={members.loading}
      membersError={members.error}
      tasksLoading={tasks.loading}
      tasksError={tasks.error}
      authRequired={members.authRequired || tasks.authRequired}
      canManage
      onAddMember={async (displayName) => { try { await createTeamMember({ display_name: displayName }) } finally { members.reload() } }}
      onMessageMember={async (userId) => { const dm = await openDm(userId); navigate(`${COMMS_ROOT}/dms/${dm.id}`) }}
      onCreateTask={async (title) => { await createTask({ title }); tasks.reload() }}
      onOpenTask={(id) => navigate(`${TEAM_ROOT}/tasks/${id}`)}
      onTaskAction={async (id, action) => {
        // REAL audited mutations from the row context menu.
        if (action === 'done') await mutateTask('update_status', { id, status: 'done' })
        else await mutateTask('set_blocker', { id, blocker_reason: 'Flagged from the task list — add detail in the task view.' })
        tasks.reload()
      }}
      onOpenRoles={() => navigate(`${TEAM_ROOT}/roles/owner`)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onNavTop={(to) => navigate(to)}
    />
  )
}
